import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
    {
        path     : '/',
        name     : 'home',
        component: () => import(/* webpackChunkName: "home" */ '@/components/HomeComponent'),
        meta     : {
            auth: true,
        },
        redirect : '/dash',
        children : [
            {
                path     : '/dash',
                name     : 'dash',
                component: () => import(/* webpackChunkName: "dash" */ '@/components/DashComponent')
            },
            {
                path     : '/archive',
                name     : 'archive',
                component: () => import(/* webpackChunkName: "dash" */ '@/components/ArchiveComponent')
            },
            {
                path     : '/productions',
                name     : 'productions',
                component: () => import(/* webpackChunkName: "production-list" */ '@/components/ProductionListComponent')
            },
            {
                path     : '/productions/:production_id/edit',
                name     : 'production-edit',
                props    : route => ({
                    production_id: route.params.production_id
                }),
                component: () => import(/* webpackChunkName: "production-edit" */ '@/components/ProductionEditComponent')
            },
            {
                path     : '/creatives',
                name     : 'creatives',
                component: () => import(/* webpackChunkName: "creative-list" */ '@/components/CreativeListComponent')
            },
            {
                path     : '/creatives/:creative_id/edit',
                name     : 'creative-edit',
                props    : route => ({
                    creative_id: String(route.params.creative_id)
                }),
                component: () => import(/* webpackChunkName: "creative-edit" */ '@/components/CreativeEditComponent.vue')
            },
            {
                path     : '/companies',
                name     : 'companies',
                component: () => import(/* webpackChunkName: "company-list" */ '@/components/CompanyListComponent')
            },
            {
                path     : '/dispatching-import-files',
                name     : 'dispatching-import-files',
                component: () => import(/* webpackChunkName: "dispatching-import-files" */ '@/components/DispatchingImportFileListComponent')
            },
            {
                path     : '/devices',
                name     : 'devices',
                component: () => import(/* webpackChunkName: "device-list" */ '@/components/DeviceListComponent')
            },
            {
                path     : '/companies/:company_id/edit',
                name     : 'company-edit',
                props    : route => ({
                    company_id: route.params.company_id
                }),
                component: () => import(/* webpackChunkName: "company-edit" */ '@/components/CompanyEditComponent')
            },
            {
                path     : '/dispatchings',
                name     : 'dispatchings',
                component: () => import(/* webpackChunkName: "dispatchings-list" */ '@/components/DispatchingListComponent')
            },
            {
                path     : '/elga-light',
                name     : 'elga-light',
                component: () => import(/* webpackChunkName: "elga-light" */ '@/components/ElgaLightImportComponent')
            },
            {
                path     : '/dispatchings/import',
                name     : 'dispatching-import',
                component: () => import(/* webpackChunkName: "dispatchings-import" */ '@/components/DispatchingImportComponent')
            },
            {
                path     : '/dispatchings/:dispatching_id/edit',
                name     : 'dispatching-edit',
                props    : route => ({
                    dispatching_id: route.params.dispatching_id,
                    dispatching_input: route.params.dispatching_input
                }),
                component: () => import(/* webpackChunkName: "dispatchings-edit" */ '@/components/DispatchingEditComponent')
            },
            {
                path     : '/disposition',
                name     : 'take-disposition',
                component: () => import(/* webpackChunkName: "take-disposition" */ '@/components/MainDispositionComponent')
            },
            {
                path     : '/disposition/import',
                name     : 'take-import',
                component: () => import(/* webpackChunkName: "take-import" */ '@/components/TakeImportComponent')
            },
            {
                path     : '/disposition/days/:dispatching_id',
                name     : 'take-day-disposition',
                component: () => import(/* webpackChunkName: "take-day-disposition" */ '@/components/DayDispositionComponent')
            },
            {
                path     : '/production_dispatchings',
                name     : 'production-dispatchings',
                component: () => import(/* webpackChunkName: "production-dispatchings-list" */ '@/components/ProductionDispatchingListComponent')
            },
            {
                path     : '/production_dispatchings/:production_dispatching_id/edit',
                name     : 'production-dispatching-edit',
                props    : route => ({
                    production_dispatching_id: route.params.production_dispatching_id,
                    production_dispatching_input: route.params.production_dispatching_input
                }),
                component: () => import(/* webpackChunkName: "production-dispatchings-edit" */ '@/components/ProductionDispatchingEditComponent')
            },
            {
                path     : '/company-salary-edit',
                name     : 'company-salary-edit',
                component: () => import(/* webpackChunkName: "company-salary-edit" */ '@/components/CompanySalaryEditComponent')
            },
            {
                path     : '/security',
                name     : 'security',
                component: () => import(/* webpackChunkName: "security" */ '@/components/TwoFactorSecurityComponent')
            },
            {
                path     : '/company-settings',
                name     : 'company-settings',
                component: () => import(/* webpackChunkName: "company-settings" */ '@/components/CompanySettingsComponent')
            },
            {
                path     : '/studios',
                name     : 'studio-list',
                component: () => import(/* webpackChunkName: "studio-list" */ '@/components/StudioListComponent')
            },
            {
                path     : '/contractors',
                name     : 'contractor-list',
                component: () => import(/* webpackChunkName: "contractor-list" */ '@/components/ContractorListComponent')
            },
            {
                path     : '/scheduling-validations',
                name     : 'scheduling-validations',
                component: () => import(/* webpackChunkName: "scheduling-validations" */ '@/components/SchedulingValidationListComponent')
            },
            {
                path     : '/invoices',
                name     : 'invoices',
                component: () => import(/* webpackChunkName: "invoices" */ '@/components/InvoicesComponent')
            },
            {
                path     : '/users',
                name     : 'users',
                component: () => import(/* webpackChunkName: "user-list" */ '@/components/UsersListComponent')
            },
            {
                path     : '/users/:user_id/edit',
                name     : 'user-edit',
                props    : route => ({
                    user_id: String(route.params.user_id)
                }),
                component: () => import(/* webpackChunkName: "user-edit" */ '@/components/UserEditComponent')
            },
            {
                path     : '/schedulings/chain/create',
                name     : 'scheduling-chain-create',
                props    : () => ({
                    scheduling_id: '-1',
                    is_chain_mode: true
                }),
                component: () => import(/* webpackChunkName: "scheduling-edit" */ '@/components/SchedulingEditComponent')
            },
            {
                path     : '/schedulings/:scheduling_id/edit',
                name     : 'scheduling-edit',
                props    : route => ({
                    scheduling_id      : route.params.scheduling_id,
                    scheduling_input   : route.params.scheduling_input,
                    dispatching_input  : route.params.dispatching_input,
                    is_dispatching_mode: route.params.is_dispatching_mode,
                    is_ensemble_mode   : route.params.is_ensemble_mode,
                    is_update_mode     : route.params.is_update_mode,
                    start_at_input     : route.params.start_at_input,
                    return_route       : route.params.return_route
                }),
                component: () => import(/* webpackChunkName: "scheduling-edit" */ '@/components/SchedulingEditComponent')
            },
            {
                path     : '/production_schedulings/:production_scheduling_id/edit',
                name     : 'production-scheduling-edit',
                props    : route => ({
                    production_scheduling_id      : route.params.production_scheduling_id,
                    production_scheduling_input   : route.params.production_scheduling_input,
                    production_dispatching_input  : route.params.production_dispatching_input,
                    creative_role                 : route.params.creative_role,
                    is_update_mode                : route.params.is_update_mode,
                }),
                component: () => import(/* webpackChunkName: "production-scheduling-edit" */ '@/components/ProductionSchedulingEditComponent')
            },
            {
                path     : '/stats',
                name     : 'stats',
                component: () => import(/* webpackChunkName: "stats" */ '@/components/StatsComponent')
            },
            {
                path     : '/invoice-months',
                name     : 'invoice-months',
                component: () => import(/* webpackChunkName: "stats" */ '@/components/InvoiceMonthEditComponent')
            },
        ]
    },
    {
        path: '/about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        // component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    },
    {
        path     : '/login',
        name     : 'login',
        component: () => import(/* webpackChunkName: "login-page" */ '@/components/LoginPage')
    },
    {
        path     : '/password-reset-request',
        name     : 'password-reset-request',
        component: () => import(/* webpackChunkName: "password-reset-request-page" */ '@/components/PasswordResetRequestPage')
    },
    {
        path     : '/password-reset',
        name     : 'password-reset',
        props    : route => ({token: route.query.token, company_id: route.params.company_id}),
        component: () => import(/* webpackChunkName: "password-reset-page" */ '@/components/PasswordResetPage')
    }


]

// (to, from, savedPosition) param list
const scrollBehavior = () => {
    return {x: 0, y: 0}
}

const router = new VueRouter({
                                 mode           : 'history',
                                 base           : process.env.BASE_URL,
                                 linkActiveClass: 'is-active',
                                 routes         : routes,
                                 scrollBehavior : scrollBehavior,
                             })

// Routes that are gated behind a company feature flag: hidden from the menu when
// the flag is off, and turned away here when reached by URL anyway. The store is
// hydrated before the router is created (main.js), so this also holds on a reload.
const featureGatedRouteNames = {
    'take-disposition'    : 'hasTakeDispositionFeature',
    'take-import'         : 'hasTakeDispositionFeature',
    'take-day-disposition': 'hasTakeDispositionFeature',
    'elga-light'          : 'hasElgaLightFeature',
}

router.beforeEach((to, from, next) => {
    const requiredFeature = featureGatedRouteNames[to.name]
    if (requiredFeature && !store.state.company?.[requiredFeature]) {
        next({name: 'dash'})
        return
    }
    next()
})

export default router